import React from 'react';

import { useMediaQuery } from '@mui/material';
import clsx from 'clsx';
import Image from 'next/image';

import filledHeartBit from '../../public/assets/filledHeartbit.png';
import styles from './heartBitBanner.module.scss';

export default function HeartBitBanner() {
  const isMediaMax1025px = useMediaQuery('(max-width: 1025px)');
  return (
    <div
      className={clsx(
        styles.banner,
        'bg-[#000000] text-white flex justify-center items-center w-[100%] px-2'
      )}
    >
      <div
        className={clsx(
          `w-full flex justify-center items-center`,
          isMediaMax1025px ? 'flex-wrap gap-2' : 'gap-5'
        )}
      >
        <div
          className={clsx(
            'flex justify-end items-center',
            isMediaMax1025px ? 'gap-2' : 'gap-5'
          )}
        >
          <Image
            src={filledHeartBit}
            alt="HeartBit"
            width={isMediaMax1025px ? 28 : 36}
            height={isMediaMax1025px ? 28 : 36}
          />

          <p
            className={clsx('font-bold text-center', {
              'text-[12px]': isMediaMax1025px,
              'text-xl': !isMediaMax1025px,
            })}
          >
            Ditch Google Docs. Explore P2P dDocs!
          </p>
          {isMediaMax1025px && (
            <Image src={filledHeartBit} alt="HeartBit" width={28} height={28} />
          )}
        </div>
        {isMediaMax1025px && <br />}
        <div className={clsx(isMediaMax1025px && 'text-xs')}>
          <button
            onClick={() => window.open('https://ddocs.new', '_blank')}
            className={clsx(
              'flex items-center  rounded-md bg-white text-black py-3 px-6 cursor-pointer',
              {
                'px-3 py-2': isMediaMax1025px,
                'py-1 px-3': !isMediaMax1025px,
              }
            )}
          >
            Try Now
          </button>
        </div>
      </div>
    </div>
  );
}
